import React, { useMemo } from 'react';
import { PlayerEditProfileDialog, editProfileIdMap } from '@colonist/clientforge';
import { getNestedTranslation } from '@colonist/i18n';
import { AudioManager, AudioType } from '@colonist/audio';
import { StoreItemCategory } from '../../../../../shared/entity_datas/StoreEnums.ts';
import { StoreItemController } from '../../../../../shared/store/StoreItemController.ts';
import { getLobbyImagePath } from '../../ui_utils/Utils.ts';
import { UIUtilsEjsVariables } from '../../UIUtilsEjsVariables.ts';
import { navigateToPage } from '../../ui_utils/ClientUtils.ts';
import { notificationController, uiManagerEvents } from '../../EntryShared.ts';
import { ProfileEditAjaxEndPoints } from '../../profile/ProfileEditAjaxEndPoints.ts';
import { showChangeUsernameDialog } from '../change_username_dialog/showChangeUsernameDialog.ts';
import { buildAvatarOptions, buildColorOptions, getSelectedAvatarId } from './buildEditProfileOptions.ts';
import { useEditProfileInfo } from './useEditProfileInfo.ts';
import { createColorSelectHandler, goToStoreColors } from './editProfileColorSelection.ts';
const getSelectedColorId = (activeColor)=>{
    if (activeColor == undefined) return undefined;
    return editProfileIdMap.toColorId(activeColor);
};
export const PlayerEditProfileDialogContainer = ({ open, onClose, selectColorAction, selectedColor, initialTab, reopen })=>{
    const info = useEditProfileInfo(open);
    const colors = useMemo(()=>info == undefined ? [] : buildColorOptions(info.availableColors), [
        info
    ]);
    const avatars = useMemo(()=>info == undefined ? [] : buildAvatarOptions(info.ownedIconTypes), [
        info
    ]);
    if (info == undefined) return null;
    const isRoomColor = selectedColor != undefined;
    const activeColor = selectedColor !== null && selectedColor !== void 0 ? selectedColor : info.preferredColor;
    const shouldHideStoreActions = UIUtilsEjsVariables.shouldHideStoreOnMobile;
    const selectColor = createColorSelectHandler({
        selectColorAction: selectColorAction,
        isRoomColor: isRoomColor,
        onClose: onClose
    });
    const selectAvatar = (avatarId)=>{
        const allIcons = StoreItemController.getItemsInCategory(StoreItemCategory.Icon, false);
        const icon = allIcons.find((storeIcon)=>storeIcon.type == editProfileIdMap.fromAvatarId(avatarId));
        if (icon == undefined) return;
        AudioManager.play(AudioType.Click);
        void ProfileEditAjaxEndPoints.updateIcon(icon.type);
        const avatarChanged = getNestedTranslation({
            key: 'strings:homePage.header.avatarSelector.avatarChanged'
        }, {
            icon: icon.name
        });
        notificationController === null || notificationController === void 0 ? void 0 : notificationController.showNotification(icon.image, avatarChanged);
        onClose();
    };
    const editUsername = (activeTab)=>{
        onClose();
        showChangeUsernameDialog({
            action: ()=>reopen(activeTab),
            triggerOnSuccess: false
        });
    };
    return /*#__PURE__*/ React.createElement(PlayerEditProfileDialog, {
        open: open,
        onClose: onClose,
        username: info.username,
        icon: getLobbyImagePath(info.icon),
        colors: colors,
        selectedColor: getSelectedColorId(activeColor),
        onColorSelect: selectColor,
        avatars: avatars,
        selectedAvatar: getSelectedAvatarId(info.icon),
        onAvatarSelect: selectAvatar,
        onUsernameClick: editUsername,
        shouldHideStoreActions: shouldHideStoreActions,
        onGoToStoreColors: goToStoreColors,
        onGoToStoreAvatars: ()=>uiManagerEvents.performRoomLeavingAction(()=>navigateToPage('/store#avatars', true, true)),
        initialTab: initialTab !== null && initialTab !== void 0 ? initialTab : isRoomColor ? 'color' : 'avatar'
    });
};
